import React, { useState, useEffect } from 'react';
import MarkdownRenderer from './MarkdownRenderer';
import LoadingState from './LoadingState';
import ErrorState from './ErrorState';
import AboutPage from '../pages/AboutPage';
import WelcomePage from '../pages/WelcomePage';
import { getPostContent } from '../services/contentService';
import './ContentViewer.css';

function ContentViewer({ slug }) {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setPost(null);
      setLoading(false);
      return;
    }

    // Special handling for about page
    if (slug === 'about') {
      setPost(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    getPostContent(slug)
      .then(data => {
        setPost(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load post:', err);
        setError(err.message);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <div className="content-viewer">
        <LoadingState />
      </div>
    );
  }

  if (error) {
    return (
      <div className="content-viewer">
        <ErrorState message={error} />
      </div>
    );
  }

  if (!post) {
    // Show About page if slug is 'about'
    if (slug === 'about') {
      return (
        <div className="content-viewer">
          <AboutPage />
        </div>
      );
    }

    // Otherwise show Welcome page
    return (
      <div className="content-viewer">
        <WelcomePage />
      </div>
    );
  }

  return (
    <div className="content-viewer">
      <article className="content-article">
        <header className="content-header">
          <h1 className="content-title">{post.title}</h1>

          <div className="content-meta">
            {post.date && (
              <span className="content-date">{new Date(post.date).toLocaleDateString()}</span>
            )}
            {post.readingTime && (
              <span className="content-reading-time">{post.readingTime} min read</span>
            )}
            {post.wordCount && (
              <span className="content-word-count">{post.wordCount} words</span>
            )}
          </div>

          {post.tags && post.tags.length > 0 && (
            <div className="content-tags">
              {post.tags.map(tag => (
                <span key={tag} className="content-tag">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </header>

        <div className="content-body prose">
          <MarkdownRenderer content={post.content} />
        </div>
      </article>
    </div>
  );
}

export default ContentViewer;
